/** Zoomstufen des Dokument-Viewers: Einpassung oder ein fester Anteil (1 = 100 %). */
export type DocumentViewerZoom = "fitWidth" | "fitPage" | number;

export const DOCUMENT_VIEWER_ZOOM_STEPS: readonly number[] = [0.5, 0.75, 1, 1.25, 1.5, 2, 2.5];
export const DOCUMENT_VIEWER_MIN_ZOOM = DOCUMENT_VIEWER_ZOOM_STEPS[0];
export const DOCUMENT_VIEWER_MAX_ZOOM = DOCUMENT_VIEWER_ZOOM_STEPS[DOCUMENT_VIEWER_ZOOM_STEPS.length - 1];
/** Eingepasste Ansichten wachsen nie über diesen Anteil hinaus. */
export const DOCUMENT_VIEWER_MAX_FIT_ZOOM = 2;
/** Ein PDF-Punkt entspricht 1/72 Zoll; 100 % bedeutet 96 dpi wie in Browser und Acrobat. */
export const PDF_CSS_UNITS = 96 / 72;

const EPSILON = 0.01;
const FIT_WIDTH = "fitWidth";
const FIT_PAGE = "fitPage";
const STORAGE_PREFIX = "mq.documentViewer.zoom.";

/** Nächste Stufe über bzw. unter dem tatsächlich angezeigten Anteil, auch aus einer Einpassung heraus. */
export function stepDocumentZoom(effective: number, direction: 1 | -1): number {
  if (direction > 0) return DOCUMENT_VIEWER_ZOOM_STEPS.find(step => step > effective + EPSILON) ?? DOCUMENT_VIEWER_MAX_ZOOM;
  return [...DOCUMENT_VIEWER_ZOOM_STEPS].reverse().find(step => step < effective - EPSILON) ?? DOCUMENT_VIEWER_MIN_ZOOM;
}

export function parseDocumentZoom(raw: string | null | undefined): DocumentViewerZoom | null {
  if (raw === FIT_WIDTH || raw === FIT_PAGE) return raw;
  const value = Number(raw);
  return raw != null && raw !== "" && Number.isFinite(value) && value >= DOCUMENT_VIEWER_MIN_ZOOM && value <= DOCUMENT_VIEWER_MAX_ZOOM ? value : null;
}

/** Gespeicherte Wahl je Gerät; localStorage kann fehlen oder werfen. */
export function readStoredDocumentZoom(key: string | undefined): DocumentViewerZoom | null {
  if (!key) return null;
  try { return parseDocumentZoom(localStorage.getItem(STORAGE_PREFIX + key)); } catch { return null; }
}

export function writeStoredDocumentZoom(key: string | undefined, zoom: DocumentViewerZoom): void {
  if (!key) return;
  try { localStorage.setItem(STORAGE_PREFIX + key, String(zoom)); } catch { /* Die Wahl bleibt dann nur für diese Ansicht. */ }
}
